import React, { useEffect, useState } from 'react';

import { Modal } from 'antd';
import Select from 'react-tailwindcss-select';
import Input from '../Input/Input';
import { useForm } from 'react-hook-form';
import { getManagerList } from '../../redux/actions/user/getManagerList';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../redux/actions/user/getUsers';
import { createNewMessage } from '../../redux/actions/chat/createNewMessage';
import Loading from '../Loading/Loading';
import { useNavigate } from 'react-router-dom';
import { resetCreateNewMessage, resetFindChat, resetSendMessage } from '../../redux/slices/chat.slice';
import { findChat } from '../../redux/actions/chat/findChat';
import { sendMessage } from '../../redux/actions/chat/sendMessage';

const options = [
  { value: 'fox', label: 'Fox' },
  { value: 'Butterfly', label: 'Butterfly' },
  { value: 'Honeybee', label: 'Honeybee' },
];

function MessageModal({ open, onCancel, user, isWrapButton }) {
  const navigate = useNavigate();
  const {
    createNewMessage: { data: createNewMessageData, error: createNewMessageError, loading: createNewMessageLoading },
    findChat: { data: findChatData, error: findChatError, loading: findChatLoading },
    sendMessage: { data: sendMessageData, error: sendMessageError, loading: sendMessageLoading },
  } = useSelector((state) => state.chat);
  const form = useForm({ defaultValues: user ? { user } : {} });
  const dispatch = useDispatch();
  const formValues = form.watch();
  const [findChatId, setFindChatId] = useState();

  useEffect(() => {
    if (sendMessageData && findChatId) {
      navigate(`/chat/${findChatId}`);
      setFindChatId();
      dispatch(resetSendMessage());
    }
  }, [sendMessageData, findChatId]);

  useEffect(() => {
    if (findChatData && !isWrapButton) {
      setFindChatId(findChatData?.id);
      dispatch(
        sendMessage({
          chat_id: findChatData?.id,
          content_type: 'text',
          text: formValues?.message,
          candidate_id: null,
        }),
      );
      dispatch(resetFindChat());
    }
  }, [findChatData]);
  const onCreateMessage = (dataUser) => {
    let senderType = 'staff';
    let receiverType = dataUser?.type;
    let senderSubtype = 'admin';
    let receiverSubtype = dataUser?.type == 'staff' ? dataUser?.role : null;
    let typeChat = receiverType == 'employer' ? 'support' : `${senderType}_${receiverType}`;
    let subtypeChat = `${senderSubtype}_${receiverSubtype}`;
    let receiverParams =
      receiverType == 'staff'
        ? { employer_id: null, type: 'staff', user_id: dataUser?.value }
        : receiverType == 'employer'
        ? {
            employer_id: dataUser?.employerId,
            type: 'employer',
            user_id: dataUser?.value,
          }
        : receiverType == 'candidate'
        ? {
            employer_id: null,
            type: 'candidate',
            user_id: dataUser?.value,
          }
        : {};
    let createMessageData = {
      vacancy_id: null,
      type: typeChat,
      ...(receiverSubtype && { subtype: subtypeChat }),
      message: {
        content_type: 'text',
        text: formValues.message,
      },
      receiver: receiverParams,
    };
    dispatch(createNewMessage(createMessageData));
  };
  useEffect(() => {
    if (findChatError && !isWrapButton) {
      const dataUser = formValues?.user;
      onCreateMessage(dataUser);
    }
  }, [findChatError]);

  useEffect(() => {
    if (createNewMessageData) {
      navigate(`/chat/${createNewMessageData?.id}`);
      dispatch(resetCreateNewMessage());
    }
  }, [createNewMessageData]);

  const handleCancel = () => {
    onCancel(false);
  };
  const onSubmitCreateMessage = () => {
    const dataUser = formValues?.user;

    onCreateMessage(dataUser);
  };
  const onSubmit = (data) => {
    let senderType = 'staff';
    let receiverType = data?.user?.type;
    let chatType = receiverType == 'employer' ? 'support' : `${senderType}_${receiverType}`;
    dispatch(findChat({ type: chatType, receiver_type: data?.user?.type, receiver_user_id: data?.user?.value, ...(data?.user?.type == 'employer' && { receiver_employer_id: data?.user?.employerId }) }));
  };

  useEffect(() => {
    form.register('user', { required: { value: true, message: '*Обязательное поле для заполнения' } });
  }, []);

  return (
    <div>
      <Modal open={open} onCancel={handleCancel} title="Написать сообщение" width={600} footer="">
        <div className="space-y-5">
          <div className="flex flex-col mx-auto gap-y-5 mt-5">
            <Input
              type={'textarea'}
              rules={{ required: true }}
              form={form}
              name={'message'}
              disabled={false}
              placeholder={'Ваше сообщение'}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  form.handleSubmit(isWrapButton ? onSubmitCreateMessage : onSubmit)();
                }
              }}
            />
            {!user && (
              <Input
                type={'search-select'}
                rules={{ required: true }}
                form={form}
                name={'user'}
                disabled={false}
                onSearch={(searchText, page) => {
                  dispatch(getUsers({ full_name: searchText, page, isAll: true }));
                }}
                placeholder={'Менеджер, контрагент или соискатель'}
                actionName={'getUsers'}
                sliceName={'user'}
                optionName={'full_name'}
              />
            )}

            <div className="flex items-center">
              {' '}
              <button className="bg-button text-white font-bold py-2 px-4 rounded-lg w-full middle:w-40" onClick={form.handleSubmit(isWrapButton ? onSubmitCreateMessage : onSubmit)}>
                Отправить
              </button>
              {createNewMessageLoading && (
                <div className="relative ml-8">
                  <Loading />
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default MessageModal;
